import { Box, Image, IconButton } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { Link as ReactLink } from "react-router-dom";
import { useState, useEffect } from "react";

const PalyazatiFloatingBadge = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const lastClosed = localStorage.getItem("palyazatBadgeClosed");

    if (lastClosed) {
      const oneHour = 60 * 60 * 1000;

      if (Date.now() - Number(lastClosed) < oneHour) {
        setVisible(false);
      }
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("palyazatBadgeClosed", Date.now());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      position="fixed"
      right="0"
      bottom="0"
      zIndex={1200}
      pointerEvents="none"
    >
      <Box position="relative" w={{ base: "170px", md: "210px" }} h="auto">
        <IconButton
          icon={<CloseIcon />}
          aria-label="Bezárás"
          size="xs"
          position="absolute"
          top="8px"
          right="8px"
          zIndex={2}
          onClick={handleClose}
          bg="white"
          _hover={{ bg: "gray.100" }}
          borderRadius="full"
          pointerEvents="auto"
        />

        <Box
          as={ReactLink}
          to="/palyazat"
          display="inline-block"
          pointerEvents="auto"
          w="100%"
        >
          <Image
            src="/images/magyarorszagkormanya.png"
            alt="Pályázatok"
            w="100%"
            h="auto"
            display="block"
            cursor="pointer"
            userSelect="none"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PalyazatiFloatingBadge;